import { createSelector } from '@reduxjs/toolkit';
import { getOrganization } from '../organization/getOrganization';
import { riskAssessmentsNotDeleted } from './risk-assessments-not-deleted';
import { calculateDataItems } from './calculate-data-items';
import type { RiskAssessmentViewModel } from '@trinnvis/dabih-api-client';
import { riskAssessmentNameWithSubstance } from './risk-assessment-name-with-substance';
import { orderBy } from 'lodash';
import { numberWord } from '../../../utilities/text';
import { groupBy } from '../utilities/groupBy';

export const riskAssessmentsReducedByName = createSelector(
  getOrganization,
  riskAssessmentsNotDeleted,
  calculateDataItems,
  function (organization, riskAssessments, dataItems): RiskAssessmentViewModel[] {
    if (organization === undefined) return [];

    const groupedRiskAssessments = groupBy(riskAssessments, (a) =>
      riskAssessmentNameWithSubstance(organization, a, dataItems),
    );
    return groupedRiskAssessments.map((r) => {
      if (r.items.length === 1) {
        return { ...r.items[0], name: r.group };
      }
      let mainTemplateId = 0;
      r.items.forEach((item) => {
        if (item.mainTemplateId) {
          mainTemplateId = item.mainTemplateId;
        }
      });
      const newest = orderBy(r.items, [(i) => i.assessmentDate, (i) => i.createdDateTime], ['desc', 'desc'])[0];
      return {
        ...newest,
        mainTemplateId: mainTemplateId,
        name:
          riskAssessmentNameWithSubstance(organization, newest, dataItems) +
          ' (' +
          numberWord(r.items.length) +
          ' vurderinger)',
      };
    });
  },
);
